<template>
    <div>
        <base-header class="pb-6"></base-header>
         <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-header">
                    <h5 class="h3 mb-0">To - Do</h5>
                </div>
                <div class="card-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item px-0" v-for="task in tasks" :key="task.id">
                            <div class="checklist-item " :class="{
                                'checklist-item-checked': task.status == 'done', 
                                'checklist-item-success': task.status == 'done', 
                                'checklist-item-danger': task.status != 'done'}">
                                <div class="flex">
                                    <div class="mr-3">
                                    <div class="custom-control custom-checkbox custom-checkbox-success">
                                        <input id="1b62d7515d212" class="custom-control-input" type="checkbox" :checked="task.status == 'done'">
                                        <label for="1b62d7515d212" class="custom-control-label"></label>
                                    </div>
                                </div>
                                <div class="checklist-info">
                                    <h5 class="checklist-title mb-0">{{ task.text }}</h5>
                                    <small>{{ task.created_at | date }} / Categoria: {{ task.area.name }}</small>
                                </div>
                                </div>
                                
                                <div>
                                    <button @click="uploadPhoto(task)" type="button" class="btn base-button btn-primary btn-sm">
                                        Completar Tarea
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
         </div>
         <div class="modal " :class="{active:showModalPhoto}">
             <div class="modal__box lg">
                 <div
                    class="modal__close"
                    @click="showModalPhoto = false"
                >
                x
                    <i class="icon-close" />
                </div>
                <div class="modal__head" >
                    <div><slot name="header-left" /></div>

                    <div>
                    <slot name="header-center" />
                    <div class="modal__title ">
                        <h3 class="mb-0">Subir imagen para completar</h3>
                    </div>
                    </div>

                    <div>
                    <slot name="header-right" />
                    </div>
                </div>
                <div class="modal__body" >
                    <div class="card-body">
                       
                        <label class="label">Foto<span style="color:red">*</span></label>
                        <input type="file" @change="onFileChange" accept="image/*" class="custom-file-input">
                        <div class="dz-preview ">
                            <div class="dz-processing dz-image-preview">
                             <img class="dz-preview-img" :src="previewUrlSRC" v-if="previewUrlSRC">
                            </div>
                        <img v-if="tempTask.image" :src="'api/task/photo/'+tempTask.image" alt="">
                        </div>
                    </div>
                </div>
                <div class="modal__footer" >
                    <div class="">
                    <button :disabled="isLoading" @click="savePhoto" class="btn base-button btn-block  btn-success">
                        <i v-if="isLoading" class="fas fa-spinner fa-spin"></i>
                        Guardar Cambios
                    </button>
                    </div>
                </div>
             </div>
         </div>
    </div>
</template>
<script>
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip} from "element-ui";
import axios from "axios";
import moment from "moment";
import CustomModal from '../../components/CustomModal.vue';
export default {
  components: { CustomModal },
    name: "Tasks",
    created() {
    this.getTasks()
    },
    data() {
        return {
        tasks: [],
        showModalPhoto: false,
        previewUrlSRC: '',
        previewUrl: '',
        tempTask: '',
        isLoading: false
        };
    },
    methods: {
        getTasks(){
            axios.get('/tasks').then((response => {
                this.tasks = response.data
            }))
        },
        uploadPhoto(task){
            this.tempTask = task
            this.showModalPhoto = true
        },
        onFileChange(event){
        const file = event.target.files[0]
        if (!file) {
          return false
        }
        if (!file.type.match('image.*')) {
          return false
        }
        const reader = new FileReader()
        const that = this
        reader.onload = function (e) {
          that.previewUrl = event.target.files[0];
          that.previewUrlSRC = e.target.result;
        }
        reader.readAsDataURL(file)
        },
        savePhoto(){
            this.isLoading = true
            const config = {
            headers: {'content-type': 'multipart/form-data'}
            }
            let formData = new FormData();
            formData.append('image', this.previewUrl);
            formData.append('id', this.tempTask.id);
            axios.post(`/task/update`, formData, config).then((response => {
                if(response.data.success){
                this.showModalPhoto = false
                this.isLoading = false
                this.previewUrlSRC = '',
                this.previewUrl = '',
                this.getTasks()
                }
            }))
        }
    },
    filters:{
        date: function(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
            }
    }, 
}
</script>
<style lang="scss" scoped>
.flex{
    display: flex;
}
.custom-file-input {
        width: 100%;
        opacity: 1;
    }

    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }

    .custom-file-input::before {
        content: 'Subir/tomar foto';
        display: inline-block;
        background: #56b57c;
        color: white;
        border-radius: 5px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-align: center;
        width: 100%;
        font-weight: 700;
        font-size: 10pt;
    }

    .custom-file-input:hover::before {
        border-color: black;
    }

    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }
</style>